import type { IconProps } from './types';

function LifebuoySharpIcon(props: IconProps) {
  const { size = 24, color = 'currentColor', ref, ...other } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      {...other}
    >
      <path
        d="M4.22202 4.22183c-4.2957651 4.29576 -4.2957651 11.26057 0 15.55637 4.29577 4.2957 11.26058 4.2957 15.55638 0 4.2957 -4.2958 4.2957 -11.26061 0 -15.55637 -4.2958 -4.2957717 -11.26061 -4.2957717 -15.55638 0Z"
        stroke={color}
        strokeWidth="1.5"
      />
      <path
        d="M8.46424 8.46447c-1.95262 1.95263 -1.95262 5.11843 0 7.07103 1.95266 1.9527 5.11846 1.9527 7.07106 0 1.9526 -1.9526 1.9526 -5.1184 0 -7.07103s-5.1184 -1.95263 -7.07106 0Z"
        stroke={color}
        strokeWidth="1.5"
      />
      <path d="m4.22168 4.22168 4.24264 4.24264" stroke={color} strokeWidth="1.5" />
      <path d="m19.7783 4.22168 -4.2426 4.24264" stroke={color} strokeWidth="1.5" />
      <path d="m15.5356 15.5356 4.2427 4.2427" stroke={color} strokeWidth="1.5" />
      <path d="m8.46436 15.5356 -4.24264 4.2427" stroke={color} strokeWidth="1.5" />
    </svg>
  );
}

export { LifebuoySharpIcon };
